import { default as Standard } from './Standard'
import { default as AutoHeight } from './AutoHeight'

export default {
  Standard,
  AutoHeight,
}
